<!--
 * @Description: 移动端页面header
 * @Date: 2021-10-31 15:59:54
 * @LastEditTime: 2022-02-15 10:58:44
-->
<template lang="pug">
  div.player-title-container(:class="isMobileVerticalLayout ? 'isMobileVerticalLayout' : 'isMobileHorizontalLayout'")
    div.top
      div.left-container
        div.player-info
          div.logo-container
            img.logo(:src="logo1" @click="toWebHomePage()")
          div.logo-container.logo-containe2
            //- img.logo(:src="logo2")
            img.logo.logo2(:src="logoImg" v-if='logoImg')
            //- comp-line-check
      div.right-container
        //- comp-layout
        //- comp-language(pageName="player")

        //- div.view-count(title="观看数")
        //-   svg-icon(icon-name="view-count")
        //-   span {{viewSum}}

        //- comp-exit
    div.player-title
      span {{ roomName }}
</template>

<script>
import compLayout from './comp-layout';
import compLanguage from './comp-language';
import compUserInfo from './comp-user-info';
import compLineCheck from '../comp-player/stream-control/comp-line-check';
import compExit from './comp-exit';
import avatar from '@/assets/img/avatar.png';
import logo1 from '@/assets/img/logo1.png';
import logo2 from '@/assets/img/logo2.png';
import { mapState } from 'vuex';
export default {
  name: 'compHeader',
  props: {
    isMobileVerticalLayout: {
      type: Boolean,
    },
    isMobileHorizontalLayout: {
      type: Boolean,
    },
  },
  data() {
    return {
      logo1,
      logo2,
      avatar,
    };
  },
  components: {
    compLayout,
    compLanguage,
    compUserInfo,
    compLineCheck,
    compExit,
  },
  computed: {
    ...mapState({
      roomName: state => state.player.roomName,
      userInfo: state => state.player.userInfo,
      liveInfo: state => state.player.liveInfo,
      viewSum: state => state.player.viewSum || '0',
      logoImg: (state) => {
        if (state?.player?.liveInfo?.logoImages && state.player.liveInfo.logoImages.length > 0) {
          return state.player.liveInfo.logoImages[0].url
        }
        return ''
      },
    }),
  },
  methods: {
    toWebHomePage: () => {
      window.location.href = 'https://www.xkb.com.cn';
    },
  },
};
</script>

<style lang="stylus" scoped>
.player-title-container
  width 100%
  height 100%
  // padding 20px 16px 10px
  // padding 10px 0
  padding-top 1px
  padding-bottom 5px
  .top
    position relative
    display flex
    justify-content space-between
    align-items: center;
    // border-bottom: 1px solid $lineColor
    box-shadow: 0 0.026667rem 0.16rem 0 rgba(53, 53, 53, 0.1);
    padding 0 10px
    .left-container
      .player-info
        height 100%
        display flex
        align-items center
        min-width 140px
        max-width 260px
        height 40px
        background-color rgba(223,223,223,0.05)
        border-radius 24px
        padding-right 10px
        .logo-container
          // width 36px
          height 36px
          // border-radius 50%
          // background-color #fff
          display flex
          justify-content center
          align-items center
          margin 0 6px 0 2px
        .logo-containe2
          max-width 50%
        .logo
          // width 24px
          // height 16px
          height 30px
        .logo2
          max-width 100%
    .right-container
      height 100%
      display flex
      // align-items flex-start
      align-items center

      .view-count
        display flex
        align-items center
        svg
          color #f00
          font-size 12px
          margin-right 5px

      // display none
      & > :not(:first-child)
        margin-left 15px
  .player-title
      padding 2px 10px 0
      text-align justify
      color $fontColor
      font-size 16px

    // 横屏
  &.isMobileHorizontalLayout
    .top
      >>> .layout
        color: #fff
    .player-title
      color $horizontalLayoutFontColor
</style>
